import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPiHoleComponent } from './simple-icons-pi-hole.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPiHoleComponent ],
    exports:      [ SimpleIconsPiHoleComponent ],
    bootstrap:    []
})
export class SimpleIconsPiHoleModule {}
